import { parseAsPageNumber } from '@shared/utils';
import { parseAsInteger, useQueryStates } from 'nuqs';

export default function useAdminExamCourseListSearchParams() {
  const [{ page, pageSize }, setQueryParams] = useQueryStates({
    page: parseAsPageNumber.withDefault(0),
    pageSize: parseAsInteger.withDefault(10),
  });

  const changePageNumber = (page: number) => {
    setQueryParams({ page });
  };

  const changePageSize = (pageSize: number) => {
    setQueryParams({ pageSize, page: 0 });
  };

  return [
    {
      page,
      pageSize,
    },
    { changePageNumber, changePageSize },
  ] as const;
}
